import { z } from "zod";
import { ArtifactSignatureSchema, FoundationActorRefSchema, FoundationAuditContextSchema, FoundationHashSchema, FoundationSemVerSchema, FoundationTimestampSchema, PatientContextRefSchema, } from "./foundation.js";
export const ApprovalArtifactStatusSchema = z.enum([
    "active",
    "partially_consumed",
    "consumed",
    "expired",
    "revoked",
    "invalidated",
]);
export const ApprovalDecisionSchema = z
    .object({
    actionId: z.string(),
    decision: z.enum(["approved", "rejected", "deferred"]),
    actionVersion: z.number().int().min(1),
    exactPayloadHash: FoundationHashSchema,
    exactPreviewHash: FoundationHashSchema.optional(),
    permittedOperations: z.array(z.string()).min(1),
    permittedDestinationIds: z.array(z.string()).optional(),
    permittedAttachmentIds: z.array(z.string()).optional(),
    acknowledgedWarningIds: z.array(z.string()),
    conditions: z.array(z.string()).optional(),
    decisionReason: z.string().optional(),
})
    .strict();
export const ApprovalArtifactSchema = z
    .object({
    schemaVersion: FoundationSemVerSchema,
    approvalId: z.string(),
    patientContext: PatientContextRefSchema,
    encounterId: z.string(),
    careBundleId: z.string(),
    careBundleVersion: z.number().int().min(1),
    bundleHash: FoundationHashSchema,
    status: ApprovalArtifactStatusSchema,
    createdAt: FoundationTimestampSchema,
    approvedAt: FoundationTimestampSchema,
    expiresAt: FoundationTimestampSchema,
    approver: FoundationActorRefSchema,
    authorizationContext: z
        .object({
        sessionId: z.string(),
        authenticationStrength: z.enum([
            "single_factor",
            "multi_factor",
            "hardware_backed",
            "delegated",
        ]),
        scopes: z.array(z.string()).min(1),
        organizationId: z.string(),
        delegationId: z.string().optional(),
        licenseJurisdiction: z.string().optional(),
        licenseIdentifier: z.string().optional(),
    })
        .strict(),
    decisions: z.array(ApprovalDecisionSchema).min(1),
    aggregateApprovedPayloadHash: FoundationHashSchema,
    revalidationRules: z
        .object({
        policyId: z.string(),
        policyVersion: z.string(),
        checks: z.array(z.string()).min(1),
        onMaterialChange: z.enum(["invalidate", "require_reapproval", "block_and_escalate"]),
        maxSnapshotAgeSeconds: z.number().int().min(0).optional(),
    })
        .strict(),
    consumption: z
        .object({
        consumedActionIds: z.array(z.string()).optional(),
        lastConsumedAt: FoundationTimestampSchema.optional(),
        transactionIds: z.array(z.string()).optional(),
    })
        .strict()
        .optional(),
    revocation: z
        .object({
        revokedAt: FoundationTimestampSchema.optional(),
        revokedBy: FoundationActorRefSchema.optional(),
        reason: z.string().optional(),
    })
        .strict()
        .optional(),
    signature: ArtifactSignatureSchema,
    auditContext: FoundationAuditContextSchema.optional(),
})
    .strict();
//# sourceMappingURL=approval-artifact.js.map